import { ICatAge } from "libs/cat-calculations/src/lib/cat-calculations.types";
import dayjs from "dayjs";

export const NUMBER_OF_DAYS_IN_A_WEEK = 7;

export const DAYS_IN_YEAR = 365;

export const NUMBER_OF_MONTHS_IN_A_YEAR = 12;

export const DEFAULT_DATE_AS_VALUE_FORMAT = "YYYY-MM-DD";
export const DEFAULT_DATE_AS_DISPLAY_FORMAT = "dddd D MMMM";
export const DEFAULT_TIME = "HH:mm";
export const LOGGING_TIME = "HH:mm:ss";
export const SHORTHAND_DATE_AS_VALUE_FORMAT = "DD/MM/YYYY";

export const toWeeks = (days: number): number => days / NUMBER_OF_DAYS_IN_A_WEEK;
export const fromWeeks = (weeks: number): number => weeks * NUMBER_OF_DAYS_IN_A_WEEK;

const DAYS_SINCE_YESTERDAY = 1;
const DAYS_UNTIL_TOMORROW = 1;

export const getNow = () => dayjs();
export const getDaysAgo = (days: number) => dayjs().subtract(days, "day");
export const getDaysUntil = (days: number) => dayjs().add(days, "day");
export const getYesterday = () => getDaysAgo(DAYS_SINCE_YESTERDAY);
export const getTomorrow = () => getDaysUntil(DAYS_UNTIL_TOMORROW);

export const getCatAgeFromDate = (date?: dayjs.ConfigType): ICatAge => {
  if (!date) {
    return { years: 0, months: 0, weeks: 0 };
  }
  const now = getNow();
  const pastDate = dayjs(date);

  const totalMonths = now.diff(pastDate, "month");

  const years = Math.floor(totalMonths / NUMBER_OF_MONTHS_IN_A_YEAR);
  const months = totalMonths % NUMBER_OF_MONTHS_IN_A_YEAR;

  const yearsAndMonths = dayjs(date).add(years, "year").add(months, "month");
  const weeks = now.diff(yearsAndMonths, "week");

  return { years, months, weeks };
};

export const formatDateString = (
  dateString: string,
  format: string | undefined = DEFAULT_DATE_AS_DISPLAY_FORMAT,
): string => dayjs(dateString).format(format);

export const getDateString = (
  date: Date | undefined,
  format: string | undefined = DEFAULT_DATE_AS_VALUE_FORMAT,
): string | undefined => {
  if (!date) { return; }
  return dayjs(date).format(format).toString();
};

export const areDatesValid = (dates: dayjs.ConfigType[]): boolean =>
  dates.length > 0
  && dates.every((date) => date !== null && date !== undefined && dayjs(date).isValid());

export const areSomeDatesValid = (dates: dayjs.ConfigType[]): boolean =>
  dates.some((date) => date !== null && date !== undefined && dayjs(date).isValid());

export const areDatesOnSameDay = (dates: dayjs.ConfigType[]): boolean => {
  if (!areDatesValid(dates)) { return false; }

  const firstDate = dayjs(dates[0]).startOf("day");

  return dates.every((date) => dayjs(date).startOf("day").isSame(firstDate));
};
